import React, { useCallback, useEffect, useState } from 'react'
import { Col, Row, Card, Table, Button } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import {
  getAllWhitelistIps,
  addWhitelistIp,
  updateWhitelistIp,
  deleteWhitelistIp,
} from '../../../../../controller/api/whitelistIp'
import WhitelistIpFormModal from '../sub-screen/WhitelistIpFormModal'

const TableRow = ({ row, onEdit, onDelete }) => (
  <tr>
    <td>
      <code>{row.ip}</code>
    </td>
    <td>{row.description || '—'}</td>
    <td>{row.createdAt ? new Date(row.createdAt).toLocaleString('vi-VN') : '—'}</td>
    <td>
      <Button variant="outline-primary" size="sm" className="m-1" onClick={() => onEdit(row)}>
        Sửa
      </Button>
      <Button variant="outline-danger" size="sm" className="m-1" onClick={() => onDelete(row)}>
        Xóa
      </Button>
    </td>
  </tr>
)

export const WhitelistIpTable = ({ currentIp }) => {
  const [cookies] = useCookies(['lottmekong'])
  const [list, setList] = useState([])
  const [formModal, setFormModal] = useState({ show: false, mode: 'add', item: null })

  const loadIps = useCallback(async () => {
    const response = await getAllWhitelistIps(cookies.lottmekong)
    if (response.error) {
      alert(response.message || 'Không tải được danh sách IP')
      return
    }
    setList(response.data || [])
  }, [cookies.lottmekong])

  useEffect(() => {
    loadIps()
  }, [loadIps])

  const handleDelete = async (row) => {
    if (!window.confirm(`Xóa IP ${row.ip} khỏi whitelist nạp tiền?`)) return
    const resp = await deleteWhitelistIp(cookies.lottmekong, row.ip)
    if (resp?.error) {
      alert(resp.message || 'Có lỗi xảy ra')
      return
    }
    loadIps()
  }

  const handleFormSubmit = async (payload) => {
    if (formModal.mode === 'add') {
      return addWhitelistIp(cookies.lottmekong, payload)
    }
    return updateWhitelistIp(cookies.lottmekong, payload)
  }

  const handleFormHide = (reload) => {
    setFormModal({ show: false, mode: 'add', item: null })
    if (reload) loadIps()
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col>
              <h5>IP được phép nạp tiền ({list.length})</h5>
              <div className="small text-muted">
                Chỉ IP trong danh sách mới được thực hiện nạp tiền tay.
              </div>
            </Col>
            <Col className="text-end">
              <Button
                variant="success"
                onClick={() => setFormModal({ show: true, mode: 'add', item: null })}
              >
                Thêm IP
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Table responsive className="align-items-center table-flush">
          <thead className="thead-light">
            <tr>
              <th>IP</th>
              <th>Mô tả</th>
              <th>Ngày tạo</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-muted">
                  Chưa có IP nào. Nạp tiền tay sẽ bị chặn cho đến khi thêm IP.
                </td>
              </tr>
            ) : (
              list.map((row) => (
                <TableRow
                  key={row.ip}
                  row={row}
                  onEdit={(item) => setFormModal({ show: true, mode: 'edit', item })}
                  onDelete={handleDelete}
                />
              ))
            )}
          </tbody>
        </Table>
      </Card>

      <WhitelistIpFormModal
        show={formModal.show}
        mode={formModal.mode}
        item={formModal.item}
        currentIp={currentIp}
        onHide={handleFormHide}
        onSubmit={handleFormSubmit}
      />
    </>
  )
}
